import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function getNYTime() {
    return new Date().toLocaleString("en-US", {
        timeZone: "America/New_York"
    });
}
